<template>
  <b-row>
    <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mt-3">
      Export load
      <div class="overflow-auto max-height-35">
        <draggable
          :list="vehiclesSelected"
          group="stockNumber"
          @start="drag = false"
          @end="drag = false"
          @change="onVehiclesSelectedChange"
        >
          <b-card v-if="vehiclesSelected.length == 0">
            Move vehicles here
          </b-card>
          <b-card v-for="vehicle in vehiclesSelected" :key="vehicle.id">
            <b-row>
              <b-col cols="10">
                <div>
                  {{ vehicle.stockNumber }} - {{ vehicle.vinNumber }}
                  <br />
                  {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model
                  }}<br />
                  {{ vehicle.color }} <br />
                  {{ vehicle.plantCountry }}
                </div>
              </b-col>
              <b-col cols="2">
                <div>
                  <b-icon
                    icon="x-circle"
                    class="cursor-pointer"
                    @click="removeFromLoad(vehicle)"
                  ></b-icon>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </draggable>
      </div>
    </b-col>
    <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mt-3">
      Vehicles
      <div class="d-flex align-items-center mb-1">
        <b-form-input
          size="sm"
          aria-describedby="input-tps-live-feedback"
          maxlength="100"
          v-model="search"
          placeholder="Search VIN/Stock"
        />
        <b-icon
          id="search-vehicles-help"
          icon="question-circle"
          variant="dark"
          class="ml-1 cursor-pointer flex-shrink-0"
        />
        <b-popover
          target="search-vehicles-help"
          triggers="hover focus"
          placement="top"
        >
          Type at least 4 characters to trigger the search.
        </b-popover>
      </div>
      <div class="overflow-auto max-height-35">
        <draggable
          :list="vehiclesFree"
          group="stockNumber"
          @start="drag = true"
          @end="drag = false"
        >
          <VehicleCard
            v-for="vehicle in vehiclesFree"
            :key="vehicle.id"
            :vehicle="vehicle"
          >
          </VehicleCard>
        </draggable>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";
import {
  GET_EXPORT_LOCATIONS_LIST_SUCCESS,
  GET_VEHICLES_LOAD,
} from "./actions";
import VehicleCard from "./VehicleCard.vue";
export default {
  name: "VehiclesList",
  props: ["vehiclesPreSelected", "location"],
  components: {
    draggable,
    VehicleCard,
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.superAdminStore.exportLoad.vehicles,
    }),
    vehiclesFree() {
      return this.vehicles.data.filter(
        (vehicle) => !this.vehiclesSelected.find((v) => v.id == vehicle.id)
      );
    },
  },
  data() {
    return {
      vehiclesSelected: [],
      search: null,
      searchTimeout: null,
    };
  },
  watch: {
    vehiclesSelected() {
      this.$emit("vehicles-selected", this.vehiclesSelected);
    },
    vehiclesPreSelected(newVal) {
      if (newVal && newVal.length > 0 && this.vehiclesSelected.length === 0) {
        this.vehiclesSelected = [...newVal];
      }
    },
    search(newVal) {
      clearTimeout(this.searchTimeout);
      const length = newVal ? newVal.trim().length : 0;
      if (length > 0 && length < 4) {
        return;
      }
      this.searchTimeout = setTimeout(() => {
        this.searchVehicles();
      }, 400);
    },
  },
  methods: {
    async onVehiclesSelectedChange(evt) {
      if (!evt.added) return;
      const vehicle = evt.added.element;
      const firstChar = (vehicle.vinNumber || "").charAt(0).toUpperCase();
      const isBuiltInUsa =
        (vehicle.plantCountry || "").trim().toUpperCase() ===
        "UNITED STATES (USA)";

      if (firstChar === "1") return;
      if (["4", "5"].includes(firstChar) && isBuiltInUsa) return;

      const message = ["4", "5"].includes(firstChar)
        ? `The VIN ${
            vehicle.vinNumber || "N/A"
          } starts with ${firstChar} but its assembly plant country is not the United States. Are you sure you want to add this vehicle to the load?`
        : `The VIN ${
            vehicle.vinNumber || "N/A"
          } does not start with 1, 4 or 5. Are you sure you want to add this vehicle to the load?`;

      const confirmed = await this.$bvModal.msgBoxConfirm(message, {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "YES",
        cancelTitle: "NO",
        cancelVariant: "danger",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
      });
      if (!confirmed) {
        this.vehiclesSelected.splice(this.vehiclesSelected.indexOf(vehicle), 1);
      }
    },
    removeFromLoad(vehicle) {
      this.vehiclesSelected.splice(this.vehiclesSelected.indexOf(vehicle), 1);
      let newFreeVehicle = this.vehicles.data.find((v) => v.id == vehicle.id);
      if (!newFreeVehicle) {
        let vehiclesNew = this.vehiclesFree;
        vehiclesNew.push(vehicle);
        this.$store.commit(GET_EXPORT_LOCATIONS_LIST_SUCCESS, vehiclesNew);
      }
    },
    searchVehicles() {
      this.$store.dispatch(GET_VEHICLES_LOAD, {
        location: this.location,
        search: this.search || undefined,
      });
    },
  },
  mounted() {
    if (this.vehiclesPreSelected?.length > 0) {
      this.vehiclesSelected = [...this.vehiclesPreSelected];
    }
  },
};
</script>

<style scoped>
.max-height-35 {
  max-height: 35rem !important;
}
</style>
